import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import columns from './columns';

const FeeHistory = ({ data }) => (
    <section className="hp-feeHistory">
        <RpTable
            data={data.feeHistory || []}
            columns={columns}
            sortable
            initialSortIdx={0}
            noDataText="No fee history data for this sire in the Racing Post database"
        />
    </section>
);

FeeHistory.propTypes = {
    data: PropTypes.shape({
        feeHistory: PropTypes.arrayOf(PropTypes.shape({
            countryCode: PropTypes.string,
            countryDesc: PropTypes.string,
            currencyCode: PropTypes.string,
            exchangeRate: PropTypes.number,
            nominationYear: PropTypes.number,
            studFee: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            studName: PropTypes.string,
        })),
    }).isRequired,
};

export default FeeHistory;



// WEBPACK FOOTER //
// ./src/js/horse/feeHistory/FeeHistory.jsx